// pages/ControlGroupsPage.jsx
import React from 'react';
import { ArrowLeft, Users, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ControlGroupsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header with Back Button */}
      <div className="mb-8">
        <button
          onClick={() => navigate('/dev-admin')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Back to Dashboard</span>
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Group Management</h1>
        <p className="text-gray-600">Manage user groups, roles, and permissions</p>
      </div>
      
      {/* Planned Feature Content */}
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-purple-100 mb-6">
            <Users className="h-12 w-12 text-purple-600" />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">Group Management Features</h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Comprehensive group management functionality is planned for future releases. This will include 
            role-based access control, user group organization, and advanced permission management.
          </p>
          <div className="flex justify-center space-x-4">
            <span className="px-4 py-2 bg-yellow-100 text-yellow-800 font-medium rounded-full">
              Planned Feature
            </span>
            <span className="px-4 py-2 bg-gray-100 text-gray-800 font-medium rounded-full">
              Future Release
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlGroupsPage;
